module.exports = __webpack_public_path__ + "ab444a477692ccb2d8fd00b9bac8f587.pdf";